/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FacultyDTO,
    FacultyDTOFromJSON,
    FacultyDTOFromJSONTyped,
    FacultyDTOToJSON,
} from './FacultyDTO';
import {
    LearningOutcomeTemplateDTO,
    LearningOutcomeTemplateDTOFromJSON,
    LearningOutcomeTemplateDTOFromJSONTyped,
    LearningOutcomeTemplateDTOToJSON,
} from './LearningOutcomeTemplateDTO';
import {
    SimpleStudyCycleEnum,
    SimpleStudyCycleEnumFromJSON,
    SimpleStudyCycleEnumFromJSONTyped,
    SimpleStudyCycleEnumToJSON,
} from './SimpleStudyCycleEnum';
import {
    StudyProgramDTO,
    StudyProgramDTOFromJSON,
    StudyProgramDTOFromJSONTyped,
    StudyProgramDTOToJSON,
} from './StudyProgramDTO';

/**
 * 
 * @export
 * @interface DomainDTO
 */
export interface DomainDTO {
    /**
     * 
     * @type {string}
     * @memberof DomainDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainDTO
     */
    readonly scienceBranchName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DomainDTO
     */
    scienceBranchId?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainDTO
     */
    readonly fundamentalDomainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DomainDTO
     */
    readonly name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DomainDTO
     */
    readonly completeName?: string | null;
    /**
     * 
     * @type {SimpleStudyCycleEnum}
     * @memberof DomainDTO
     */
    studyCycle?: SimpleStudyCycleEnum;
    /**
     * 
     * @type {Array<FacultyDTO>}
     * @memberof DomainDTO
     */
    faculties?: Array<FacultyDTO> | null;
    /**
     * 
     * @type {Array<StudyProgramDTO>}
     * @memberof DomainDTO
     */
    studyPrograms?: Array<StudyProgramDTO> | null;
    /**
     * 
     * @type {string}
     * @memberof DomainDTO
     */
    branchName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DomainDTO
     */
    abbreviation?: string | null;
    /**
     * 
     * @type {Array<LearningOutcomeTemplateDTO>}
     * @memberof DomainDTO
     */
    learningKnowledgeOutcome?: Array<LearningOutcomeTemplateDTO> | null;
    /**
     * 
     * @type {Array<LearningOutcomeTemplateDTO>}
     * @memberof DomainDTO
     */
    learningSkillOutcome?: Array<LearningOutcomeTemplateDTO> | null;
    /**
     * 
     * @type {Array<LearningOutcomeTemplateDTO>}
     * @memberof DomainDTO
     */
    learningResponsabilityOutcome?: Array<LearningOutcomeTemplateDTO> | null;
}

export function DomainDTOFromJSON(json: any): DomainDTO {
    return DomainDTOFromJSONTyped(json, false);
}

export function DomainDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'scienceBranchName': !exists(json, 'scienceBranchName') ? undefined : json['scienceBranchName'],
        'scienceBranchId': !exists(json, 'scienceBranchId') ? undefined : json['scienceBranchId'],
        'fundamentalDomainName': !exists(json, 'fundamentalDomainName') ? undefined : json['fundamentalDomainName'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'completeName': !exists(json, 'completeName') ? undefined : json['completeName'],
        'studyCycle': !exists(json, 'studyCycle') ? undefined : SimpleStudyCycleEnumFromJSON(json['studyCycle']),
        'faculties': !exists(json, 'faculties') ? undefined : (json['faculties'] === null ? null : (json['faculties'] as Array<any>).map(FacultyDTOFromJSON)),
        'studyPrograms': !exists(json, 'studyPrograms') ? undefined : (json['studyPrograms'] === null ? null : (json['studyPrograms'] as Array<any>).map(StudyProgramDTOFromJSON)),
        'branchName': !exists(json, 'branchName') ? undefined : json['branchName'],
        'abbreviation': !exists(json, 'abbreviation') ? undefined : json['abbreviation'],
        'learningKnowledgeOutcome': !exists(json, 'learningKnowledgeOutcome') ? undefined : (json['learningKnowledgeOutcome'] === null ? null : (json['learningKnowledgeOutcome'] as Array<any>).map(LearningOutcomeTemplateDTOFromJSON)),
        'learningSkillOutcome': !exists(json, 'learningSkillOutcome') ? undefined : (json['learningSkillOutcome'] === null ? null : (json['learningSkillOutcome'] as Array<any>).map(LearningOutcomeTemplateDTOFromJSON)),
        'learningResponsabilityOutcome': !exists(json, 'learningResponsabilityOutcome') ? undefined : (json['learningResponsabilityOutcome'] === null ? null : (json['learningResponsabilityOutcome'] as Array<any>).map(LearningOutcomeTemplateDTOFromJSON)),
    };
}

export function DomainDTOToJSON(value?: DomainDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'scienceBranchId': value.scienceBranchId,
        'studyCycle': SimpleStudyCycleEnumToJSON(value.studyCycle),
        'faculties': value.faculties === undefined ? undefined : (value.faculties === null ? null : (value.faculties as Array<any>).map(FacultyDTOToJSON)),
        'studyPrograms': value.studyPrograms === undefined ? undefined : (value.studyPrograms === null ? null : (value.studyPrograms as Array<any>).map(StudyProgramDTOToJSON)),
        'branchName': value.branchName,
        'abbreviation': value.abbreviation,
        'learningKnowledgeOutcome': value.learningKnowledgeOutcome === undefined ? undefined : (value.learningKnowledgeOutcome === null ? null : (value.learningKnowledgeOutcome as Array<any>).map(LearningOutcomeTemplateDTOToJSON)),
        'learningSkillOutcome': value.learningSkillOutcome === undefined ? undefined : (value.learningSkillOutcome === null ? null : (value.learningSkillOutcome as Array<any>).map(LearningOutcomeTemplateDTOToJSON)),
        'learningResponsabilityOutcome': value.learningResponsabilityOutcome === undefined ? undefined : (value.learningResponsabilityOutcome === null ? null : (value.learningResponsabilityOutcome as Array<any>).map(LearningOutcomeTemplateDTOToJSON)),
    };
}

